import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
//i18n
import { withTranslation } from "react-i18next";

// import logoSm from "../../assets/images/logo-sm.png";
import logoSm from "../../assets/images/optimize_logo light.png";
import logoLight from "../../assets/images/optimize_logo dark.png";
import logoDark from "../../assets/images/optimize_logo light.png";
import aptivDark from "../../assets/images/aptiv.jpg";
import aptivLIght from "../../assets/images/aptive1.png";

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";
import ProfileMenu from "../../components/Common/TopbarDropdown/ProfileMenu";

const Header = (props) => {
  const [search, setsearch] = useState(false);
  const companyId = localStorage.getItem("companyid");
  const [selectedCompanyLogo, setSelectedCompanyLogo] = useState(localStorage.getItem("company_logo_light") || "");
  const authToken = useMemo(() => localStorage.getItem("access"), []);
  const role = useMemo(() => localStorage.getItem("role"), []);

  function toggleFullscreen() {
    // ... (fullscreen logic remains unchanged)
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }

  useEffect(() => {
    async function fetchCompanyLogos() {
      // Check if logo is already loaded to avoid unnecessary API calls
      if (selectedCompanyLogo) return; 

      try {
        const response = await fetch("https://api.hvacsync.in/api/companies/1/logo/",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        
        // Check for 401 Unauthorized before attempting response.json()
        if (response.status === 401) {
             console.error("Authentication error while fetching logo.");
             return;
        }

        const data = await response.json();
        const logoUrl = data?.logo;
        
        if (logoUrl) {
            localStorage.setItem("company_logo_light", logoUrl);
            setSelectedCompanyLogo(logoUrl);
        }

      } catch (error) {
        console.error("Error fetching company logo:", error);
      }
    }
    fetchCompanyLogos();
  }, [authToken, selectedCompanyLogo]);


  
  return (
    <React.Fragment>
      <header id="page-topbar" className="pb-2 pt-1">
        <div className="navbar-header">
          {/* Main alignment container: Removed mt-4 for tighter vertical space */}
          <div className="d-flex align-items-center"> 
            
            {/* Toggle Button Wrapper: Removed py-5 */}
            <div className="py-2 px-1"> 
              <button
                type="button"
                // Simplified button padding/margin for alignment
                className="btn btn-sm px-3 font-size-24 header-item waves-effect" 
                id="vertical-menu-btn"
                onClick={() => {
                  tToggle();
                }}
              >
                <i className="ri-menu-2-line align-middle"></i>
              </button>
            </div>
            
            {/* Logo container: Adjusted padding and ensures items are centered */}
            <div
              className="navbar-brand-box text-left p-0 d-flex align-items-center"
            >
              
              {/* Logo Link - Dark Mode */}
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm p-0">
                  {/* Reduced height for better vertical alignment in header */}
                  <img src={`https://api.hvacsync.in/media/${selectedCompanyLogo}`} alt="logo-sm-dark" height="60" className="p-0" /> 
                </span>
                <span className="logo-lg">
                  {/* Reduced height for better vertical alignment in header */}
                  <img src={`https://api.hvacsync.in/media/${selectedCompanyLogo}`} alt="logo-dark" height="60" className="p-0" /> 
                </span>
              </Link>

              {/* Logo Link - Light Mode (Currently commented out in original) */}
              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  {/* <img src={`https://api.hvacsync.in/media/${selectedCompanyLogo}`} alt="logo-sm-light" height="60" /> */}
                </span>
                <span className="logo-lg">
                  {/* <img src={`https://api.hvacsync.in/media/${selectedCompanyLogo}`} alt="logo-light" height="60" /> */}
                </span>
              </Link> 
            </div>
            
          </div>

          <div className="d-flex">
            {/* Placeholder for other right-side elements, if any */}
          </div>
          
          <div className="d-flex">
            <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen();
                }}
                className="btn header-item noti-icon"
                data-toggle="fullscreen"
              >
                <i className="ri-fullscreen-line" />
              </button>
            </div>

            <ProfileMenu />
          </div>
          
        </div>
      </header>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));